// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button-big_wrapper__iQnFY","primary":"button-big_primary__X6KgN","secondary":"button-big_secondary__TuDxf","tertiary":"button-big_tertiary__ql11I"};